import { render, staticRenderFns } from "./MiniProfileComponent.vue?vue&type=template&id=c6e0a724&scoped=true"
import script from "./MiniProfileComponent.vue?vue&type=script&lang=js"
export * from "./MiniProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./MiniProfileComponent.vue?vue&type=style&index=0&id=c6e0a724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e0a724",
  null
  
)

export default component.exports